import { MdRadioButtonChecked, MdOutlineRadioButtonUnchecked } from "react-icons/md";

export default function Position(props) {
   const {item, values, setValue, sectionData} = props;
   const currentSection = sectionData?.currentSection;
   
   const id = item.id;
   const value = values[currentSection.formId + id];

   function onChange(e) {
      const dataid = parseInt(e.currentTarget?.dataset?.id||"0");
      setValue(id, dataid);
   }

   const numericValue = value !== undefined && value !== ''
      ? Number(value)
      : undefined;

   return (
      <div key={id} className="element position">
         <div className="caption">
            <span className="title">{item.caption}</span>
            <span className="subtitle">{item.subtitle}</span>
         </div>
         <div className="options">
            {item.options.map((o, i) => {
               return (
                  <span
                     onClick={onChange}
                     key={i}
                     data-id={o.value}
                     className={`selection${numericValue === undefined ? '' : numericValue === o.value ? ' selected' : ' notSelected'}`}
                  >
                     <div>
                        {(numericValue && numericValue === o.value) ?
                           <MdRadioButtonChecked className="actionIcon" /> :
                           <MdOutlineRadioButtonUnchecked className="actionIcon" />
                        }
                        <span className="optionName">{o.name}</span>
                     </div>
                     <span className="optionDescription">{o.subtitle}</span>
                  </span>
               );
            })}
         </div>
      </div>
   );
}
